import React, { Component } from 'react';
import { ListTabButton } from '../../list-tab/list-tab-button.component';
import ButtonIcon from '../../../button';
import { Selected_Index } from '../../../../constants/external-constants';
import IconTab from '../../icon-tab/icon-tab.component';

class DetailContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
        };
    }

    componentDidMount() {
        this.setState({ selectedIndex: this.props.urlIndex });
    }

    FilterIndex = (tabIndex) => {
        const {renderTabContent} = this.props;
        this.setState({ selectedIndex: tabIndex });
        renderTabContent(tabIndex)
    }

    handlecloseForm = () =>{
        const {handleClose} = this.props;
        handleClose();
    }

    activeListTab = (listTab) => {

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && (this.props.billingAccountId > 0 || this.props.equipmentId > 0)) {
                disabled = false;
            }
            return {
                ...item,
                disable: disabled
            };
        })
    }

    handleTabIconClick = (index, disabled) =>{
        const {onhandleIconClick } = this.props;
        if(onhandleIconClick && !disabled) {
            onhandleIconClick(index)
        }
    }

    render() {
        const {children, listTab, showBackButton, customClass, tabListIcon, onhandleIconClick, hideTabIcon } = this.props;
        return (
            <div className={`layout-container ${customClass}`}>
                {showBackButton? <ButtonIcon onClick={this.handlecloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" /> : null}
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex} /> 
                : null}
                {
                    (tabListIcon && !hideTabIcon) &&
                    <div className="icon-tab__container">
                        {tabListIcon.map((tab, index) => (
                            <IconTab 
                                key={index} 
                                {...tab} 
                                onClick={() => this.handleTabIconClick(index, tab.disabled)} 
                                lastIcon = {index === tabListIcon.length - 1}
                            />
                        ))}
                    </div>
                }                
                <div  className={`${this?.props?.isMultiContainer? "" : "details-container"} date-picker-main-container`}>
                    {children}
                </div>
            </div>
        );
    }
}



export default DetailContainer;